

import { useQuery } from "@tanstack/react-query";
import type { SubscriptionPlanListResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

export function useSubscriptionsQuery() {
  const query = useQuery({
    queryKey: queryKeys.admin.subscriptions(),
    queryFn: () => apiJsonClient<SubscriptionPlanListResponse>(endpoints.admin.subscriptions),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
